<template>
  <div
    class="c-container"
    :style="style"
  >
    <slot />
  </div>
</template>

<script>
export default {
  name: 'CContainer',
  props: {
    size: {
      type: String,
      default: 'normal',
    },
    paddingSize: {
      type: String,
      default: 'normal',
    },
  },
  computed: {
    style() {
      const middlewares = [
        this.makeSize,
        this.makePadding,
      ];
      return middlewares.reduce((res, m) => {
        res = m(res);
        return res;
      }, {});
    },
  },
  methods: {
    makePadding(style) {
      if (this.paddingSize === 'none') {
        return style;
      }
      if (this.paddingSize === 'xs') {
        return {
          ...style,
          padding: '1.6rem',
        };
      }
      if (this.paddingSize === 'small') {
        return {
          ...style,
          padding: '2rem',
        };
      }

      return {
        ...style,
        padding: '4rem',
      };
    },
    makeSize(style) {
      if (this.size === 'small') {
        return {
          ...style,
          maxWidth: '800px',
        };
      }
      return {
        ...style,
        maxWidth: '1300px',
      };
    },
  },
};
</script>

<style
    scoped
    lang="scss"
    type="text/scss"
>
  .c-container {
    margin: 0 auto;
  }
</style>
